import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SnackBar from "./SnackBar";
import { styled } from "@mui/system";
import { read_card } from "../Api service/APIvariables";
import UploadImage from "../assets/uploadImage.png";

const DragDropArea = styled(Box)(({ theme }) => ({
  border: "2px dashed #453c72",
  borderRadius: "8px",
  padding: "20px",
  textAlign: "center",
  color: "#453c72",
  cursor: "pointer",
  marginBottom: "20px",
}));

const UploadCard = ({ onDataUpdate }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [notification, setNotification] = useState("");
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const user_id = localStorage.getItem("user_id");

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false); // Default Snackbar color
  const [message, setMessage] = useState("");

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      setOpen(true);
      setStatus(true);
      setColor(true);
      setMessage("Image selected successfully!");
      // setNotification("Image selected successfully!");
    }
  };

  const fileClick = () => {
    const fileUpload = document.getElementById("file-upload");
    if (fileUpload) {
      fileUpload.click(); // Triggers the file input click event
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      setPreview(URL.createObjectURL(droppedFile));

      // setNotification("Image selected successfully!");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleSubmit = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("user_id", user_id);
      setIsProcessing(true);
      setNotification("");

      const token = localStorage.getItem("auth_token");

      try {
        // Claudia method image upload request
        const response = await fetch(read_card, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        if (!response.ok) {
          throw new Error("Failed to upload the image.");
        }

        const data = await response.json();

        if (data) {
          // setNotification("Image uploaded and processed successfully!");
          setFile(null);
          setPreview(null);
          setOpen(true);
          setStatus(true);
          setColor(true);
          setMessage(data.message);
        } else {
          // Failure : Reset file and preview
          setFile(null);
          setPreview(null);
          setOpen(true);
          setStatus(false);
          setColor(false);
          setMessage(data.message);
        }
      } catch (err) {
        setError(err.message);
        setFile(null);
        setPreview(null);
      } finally {
        setIsProcessing(false);
      }
    } else {
      setMessage("Please upload an image before submitting.");
    }
  };

  const handleCloseNotification = () => {
    setNotification("");
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "90vh",
        backgroundColor: "#eceff1",
        padding: isMobile ? "10px" : "40px",
        // borderRadius: "30px",
      }}
    >
      <SnackBar
        open={open}
        message={message}
        setOpen={setOpen}
        status={status}
        color={color}
      />
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          backgroundColor: "#eceff1",
          fontSize: isMobile ? "20px" : "28px",
          color: "#453c72",
        }}
      >
        Upload Your Card Here
      </Typography>

      <DragDropArea
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={fileClick}
        // onChange={handleFileSelect}
        style={{
          // color: "#453c72",
          backgroundColor: "#d6dfff",
          boxShadow: "0 6px 10px rgb(69,60,114)",
        }}
      >
        <img
          src={UploadImage}
          alt="Upload Icon"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "contain",
          }}
        />
        <Typography
          sx={{
            fontSize: isMobile ? "10px" : "16px",
            fontWeight: 600,
            color: "black",
          }}
        >
          Drag & Drop <span style={{ color: "#453c72" }}>Files</span> Here or{" "}
          <span style={{ color: "#453c72" }}>Click to select</span>
        </Typography>
        <input
          type="file"
          style={{ display: "none" }}
          id="file-upload"
          accept="image/*"
          onChange={handleFileSelect}
        />
        <Button
          variant="contained"
          component="span"
          sx={{
            mt: 2,
            backgroundColor: "#453c72",
            color: "white",
            fontSize: isMobile ? "10px" : "16px",
            padding: isMobile ? "6px 12px" : "8px 16px",
            textTransform: "none",
          }}
        >
          Upload Images
        </Button>
      </DragDropArea>

      {preview && (
        <Box
          sx={{
            width: "100%",
            maxWidth: "300px",
            marginTop: "20px",
            textAlign: "center",
          }}
        >
          <img
            src={preview}
            alt="Preview"
            style={{
              width: "100%",
              borderRadius: "8px",
              border: "2px solid #453c72",
            }}
          />
          <Typography variant="caption" sx={{ color: "#453c72", mt: 1 }}>
            Selected Image Preview
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={isProcessing}
        sx={{
          marginTop: { xs: "20px", sm: "30px", md: "40px" },
          backgroundColor: isProcessing ? "#aaa" : "#453c72",
          color: "white",
          fontSize: isMobile ? "10px" : "16px",
          padding: isMobile ? "6px 12px" : "8px 16px",
          textTransform: "none",
        }}
      >
        {isProcessing ? "Processing..." : "Submit"}
      </Button>

      {/* <Snackbar
        open={!!notification}
        autoHideDuration={3000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity="success"
          sx={{ width: "100%" }}
        >
          {notification}
        </Alert>
      </Snackbar> */}

      {/* {error && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          onClose={() => setError(null)}
        >
          <Alert
            onClose={() => setError(null)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {error}
          </Alert>
        </Snackbar>
      )} */}
    </Box>
  );
};

export default UploadCard;
